import { useState, useEffect } from "react";
import { useRegister } from "../../context/RegisterContext";
import { useVerification } from "../../context/VerificationContext";

import "./Register.css";
import { useNavigate, Link } from "react-router-dom";

import qkLogo from "../../assets/qk_logo.png";

// const Register = () => {
//   const { registerUser, loading, error } = useRegister();

//   const [form, setForm] = useState({
//     firstName: "",
//     middleName: "",
//     lastName: "",
//     email: "",
//     phone: "",
//     password: "",
//     confirmPassword: "",
//     isMFA: false,
//     address1: "",
//     address2: "",
//     city: "",
//     state: "",
//     country: "",
//     zipcode: "",
//     countryCode: "",
//   });

//   const [errors, setErrors] = useState({});
//   const [showModal, setShowModal] = useState(false);
//   const [modalMessage, setModalMessage] = useState("");
//   const [modalType, setModalType] = useState("success"); // success | error

//   const countries = [
//     { name: "India", code: "+91", zipcodes: ["440001", "400001", "110001"] },
//     { name: "USA", code: "+1", zipcodes: ["10001", "90001", "73301"] },
//     { name: "UK", code: "+44", zipcodes: ["SW1A", "EC1A", "W1A"] },
//   ];

//   const selectedCountry = countries.find((c) => c.name === form.country);

//   /* ================= VALIDATION ================= */
//   const validate = () => {
//     const newErrors = {};

//     if (!form.firstName.trim()) newErrors.firstName = "First name required";
//     if (!form.lastName.trim()) newErrors.lastName = "Last name required";

//     if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
//       newErrors.email = "Invalid email address";
//     }

//     if (!/^\d{10}$/.test(form.phone)) {
//       newErrors.phone = "Phone must be 10 digits";
//     }

//     if (!form.password || form.password.length < 6) {
//       newErrors.password = "Password must be at least 6 characters";
//     }

//     if (form.password !== form.confirmPassword) {
//       newErrors.confirmPassword = "Passwords do not match";
//     }

//     if (!form.country) newErrors.country = "Country required";
//     if (!form.zipcode) newErrors.zipcode = "Zipcode required";

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   /* ================= HANDLERS ================= */
//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setForm({ ...form, [name]: type === "checkbox" ? checked : value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validate()) return;

//     try {
//       await registerUser(form);

//       setModalType("success");
//       setModalMessage("Registration successful. Data sent to backend.");
//       setShowModal(true);
//     } catch (err) {
//       setModalType("error");
//       setModalMessage("Registration failed. Please try again.");
//       setShowModal(true);
//     }
//   };

//   return (
//     <div className="reg-page-wrapper">
//       <h2 className="reg-page-title">Register</h2>

//       <form className="reg-form" onSubmit={handleSubmit}>
//         {/* Name Fields */}
//         <input
//           className="reg-input"
//           name="firstName"
//           placeholder="First Name"
//           onChange={handleChange}
//         />
//         {errors.firstName && <p className="reg-error">{errors.firstName}</p>}

//         <input
//           className="reg-input"
//           name="middleName"
//           placeholder="Middle Name"
//           onChange={handleChange}
//         />

//         <input
//           className="reg-input"
//           name="lastName"
//           placeholder="Last Name"
//           onChange={handleChange}
//         />
//         {errors.lastName && <p className="reg-error">{errors.lastName}</p>}

//         {/* Contact */}
//         <input
//           className="reg-input"
//           name="email"
//           placeholder="Email Address"
//           onChange={handleChange}
//         />
//         {errors.email && <p className="reg-error">{errors.email}</p>}

//         <input
//           className="reg-input"
//           name="phone"
//           placeholder="Phone Number"
//           maxLength={10}
//           onChange={handleChange}
//         />
//         {errors.phone && <p className="reg-error">{errors.phone}</p>}

//         {/* Password */}
//         <input
//           className="reg-input"
//           type="password"
//           name="password"
//           placeholder="Password"
//           onChange={handleChange}
//         />
//         {errors.password && <p className="reg-error">{errors.password}</p>}

//         <input
//           className="reg-input"
//           type="password"
//           name="confirmPassword"
//           placeholder="Confirm Password"
//           onChange={handleChange}
//         />
//         {errors.confirmPassword && (
//           <p className="reg-error">{errors.confirmPassword}</p>
//         )}

//         {/* Country */}
//         <select className="reg-select" name="country" onChange={handleChange}>
//           <option value="">Select Country</option>
//           {countries.map((c) => (
//             <option key={c.name} value={c.name}>
//               {c.name}
//             </option>
//           ))}
//         </select>
//         {errors.country && <p className="reg-error">{errors.country}</p>}

//         <select
//           className="reg-select"
//           name="countryCode"
//           onChange={handleChange}
//         >
//           <option value="">Country Code</option>
//           {countries.map((c) => (
//             <option key={c.code} value={c.code}>
//               {c.code}
//             </option>
//           ))}
//         </select>

//         <select className="reg-select" name="zipcode" onChange={handleChange}>
//           <option value="">Select Zipcode</option>
//           {selectedCountry?.zipcodes.map((z) => (
//             <option key={z} value={z}>
//               {z}
//             </option>
//           ))}
//         </select>
//         {errors.zipcode && <p className="reg-error">{errors.zipcode}</p>}

//         {/* Address */}
//         <input
//           className="reg-input"
//           name="address1"
//           placeholder="Address Line 1"
//           onChange={handleChange}
//         />
//         <input
//           className="reg-input"
//           name="address2"
//           placeholder="Address Line 2"
//           onChange={handleChange}
//         />
//         <input
//           className="reg-input"
//           name="city"
//           placeholder="City"
//           onChange={handleChange}
//         />
//         <input
//           className="reg-input"
//           name="state"
//           placeholder="State"
//           onChange={handleChange}
//         />

//         {/* MFA */}
//         <label className="reg-checkbox">
//           <input type="checkbox" name="isMFA" onChange={handleChange} />
//           Enable MFA
//         </label>

//         <button className="reg-submit-btn" disabled={loading}>
//           {loading ? "Registering..." : "Register"}
//         </button>
//       </form>

//       {/* ================= MODAL ================= */}
//       {showModal && (
//         <div className="reg-modal-overlay">
//           <div className="reg-modal">
//             <h3
//               className={
//                 modalType === "success"
//                   ? "reg-modal-success"
//                   : "reg-modal-error"
//               }
//             >
//               {modalType === "success" ? "Success" : "Error"}
//             </h3>
//             <p>{modalMessage}</p>
//             <button
//               className="reg-modal-btn"
//               onClick={() => setShowModal(false)}
//             >
//               OK
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };
// const Register = () => {
//   const { registerUser, loading, error } = useRegister();

//   const [form, setForm] = useState({
//     firstName: "",
//     middleName: "",
//     lastName: "",
//     email: "",
//     phone: "",
//     password: "",
//     confirmPassword: "",
//     isMFA: false,
//     address1: "",
//     address2: "",
//     city: "",
//     state: "",
//     country: "",
//     zipcode: "",
//     countryCode: "",
//   });

//   const [errors, setErrors] = useState({});
//   const [showModal, setShowModal] = useState(false);
//   const [modalMessage, setModalMessage] = useState("");
//   const [modalType, setModalType] = useState("success"); // success | error

//   const countries = [
//     { name: "India", code: "+91", zipcodes: ["440001", "400001", "110001"] },
//     { name: "USA", code: "+1", zipcodes: ["10001", "90001", "73301"] },
//     { name: "UK", code: "+44", zipcodes: ["SW1A", "EC1A", "W1A"] },
//   ];

//   const selectedCountry = countries.find((c) => c.name === form.country);

//   /* ================= VALIDATION ================= */
//   const validate = () => {
//     const newErrors = {};

//     if (!form.firstName.trim()) newErrors.firstName = "First name required";
//     if (!form.lastName.trim()) newErrors.lastName = "Last name required";

//     if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
//       newErrors.email = "Invalid email address";
//     }

//     if (!/^\d{10}$/.test(form.phone)) {
//       newErrors.phone = "Phone must be 10 digits";
//     }

//     if (!form.password || form.password.length < 6) {
//       newErrors.password = "Password must be at least 6 characters";
//     }

//     if (form.password !== form.confirmPassword) {
//       newErrors.confirmPassword = "Passwords do not match";
//     }

//     if (!form.country) newErrors.country = "Country required";
//     if (!form.zipcode) newErrors.zipcode = "Zipcode required";

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   /* ================= HANDLERS ================= */
//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setForm({ ...form, [name]: type === "checkbox" ? checked : value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validate()) return;

//     try {
//       await registerUser(form);

//       setModalType("success");
//       setModalMessage("Registration successful. Data sent to backend.");
//       setShowModal(true);
//     } catch (err) {
//       setModalType("error");
//       setModalMessage("Registration failed. Please try again.");
//       setShowModal(true);
//     }
//   };

//   return (
//     <div className="reg-page-wrapper">
//       <h2 className="reg-page-title">Register</h2>

//       <form className="reg-form" onSubmit={handleSubmit}>
//         {/* Name Fields */}
//         <input
//           className="reg-input"
//           name="firstName"
//           placeholder="First Name"
//           onChange={handleChange}
//         />
//         {errors.firstName && <p className="reg-error">{errors.firstName}</p>}

//         <input
//           className="reg-input"
//           name="middleName"
//           placeholder="Middle Name"
//           onChange={handleChange}
//         />

//         <input
//           className="reg-input"
//           name="lastName"
//           placeholder="Last Name"
//           onChange={handleChange}
//         />
//         {errors.lastName && <p className="reg-error">{errors.lastName}</p>}

//         {/* Contact */}
//         <input
//           className="reg-input"
//           name="email"
//           placeholder="Email Address"
//           onChange={handleChange}
//         />
//         {errors.email && <p className="reg-error">{errors.email}</p>}

//         <input
//           className="reg-input"
//           name="phone"
//           placeholder="Phone Number"
//           maxLength={10}
//           onChange={handleChange}
//         />
//         {errors.phone && <p className="reg-error">{errors.phone}</p>}

//         {/* Password */}
//         <input
//           className="reg-input"
//           type="password"
//           name="password"
//           placeholder="Password"
//           onChange={handleChange}
//         />
//         {errors.password && <p className="reg-error">{errors.password}</p>}

//         <input
//           className="reg-input"
//           type="password"
//           name="confirmPassword"
//           placeholder="Confirm Password"
//           onChange={handleChange}
//         />
//         {errors.confirmPassword && (
//           <p className="reg-error">{errors.confirmPassword}</p>
//         )}

//         {/* Country */}
//         <select className="reg-select" name="country" onChange={handleChange}>
//           <option value="">Select Country</option>
//           {countries.map((c) => (
//             <option key={c.name} value={c.name}>
//               {c.name}
//             </option>
//           ))}
//         </select>
//         {errors.country && <p className="reg-error">{errors.country}</p>}

//         <select
//           className="reg-select"
//           name="countryCode"
//           onChange={handleChange}
//         >
//           <option value="">Country Code</option>
//           {countries.map((c) => (
//             <option key={c.code} value={c.code}>
//               {c.code}
//             </option>
//           ))}
//         </select>

//         <select className="reg-select" name="zipcode" onChange={handleChange}>
//           <option value="">Select Zipcode</option>
//           {selectedCountry?.zipcodes.map((z) => (
//             <option key={z} value={z}>
//               {z}
//             </option>
//           ))}
//         </select>
//         {errors.zipcode && <p className="reg-error">{errors.zipcode}</p>}

//         {/* Address */}
//         <input
//           className="reg-input"
//           name="address1"
//           placeholder="Address Line 1"
//           onChange={handleChange}
//         />
//         <input
//           className="reg-input"
//           name="address2"
//           placeholder="Address Line 2"
//           onChange={handleChange}
//         />
//         <input
//           className="reg-input"
//           name="city"
//           placeholder="City"
//           onChange={handleChange}
//         />
//         <input
//           className="reg-input"
//           name="state"
//           placeholder="State"
//           onChange={handleChange}
//         />

//         {/* MFA */}
//         <label className="reg-checkbox">
//           <input type="checkbox" name="isMFA" onChange={handleChange} />
//           Enable MFA
//         </label>

//         <button className="reg-submit-btn" disabled={loading}>
//           {loading ? "Registering..." : "Register"}
//         </button>
//       </form>

//       {/* ================= MODAL ================= */}
//       {showModal && (
//         <div className="reg-modal-overlay">
//           <div className="reg-modal">
//             <h3
//               className={
//                 modalType === "success"
//                   ? "reg-modal-success"
//                   : "reg-modal-error"
//               }
//             >
//               {modalType === "success" ? "Success" : "Error"}
//             </h3>
//             <p>{modalMessage}</p>
//             <button
//               className="reg-modal-btn"
//               onClick={() => setShowModal(false)}
//             >
//               OK
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

//old ui working code
// const Register = () => {
//   const { registerUser, loading, error } = useRegister();
//   const { startVerificationWatch, isVerified } = useVerification();
//   const navigate = useNavigate();

//   const [form, setForm] = useState({
//     firstName: "",
//     middleName: "",
//     lastName: "",
//     email: "",
//     phone: "",
//     password: "",
//     confirmPassword: "",
//     isMFA: false,
//     address1: "",
//     address2: "",
//     city: "",
//     state: "",
//     country: "",
//     zipcode: "",
//     countryCode: "",
//     isPaid: false,
//   });

//   const [errors, setErrors] = useState({});
//   const [showModal, setShowModal] = useState(false);
//   const [apiMessage, setApiMessage] = useState("");
//   const [isError, setIsError] = useState(false);
//   const [modalMessage, setModalMessage] = useState("");
//   const [modalType, setModalType] = useState("success");
//   const [waitingForVerification, setWaitingForVerification] = useState(false);

//   const countries = [
//     { name: "India", code: "+91", zipcodes: ["440001", "400001", "110001"] },
//     { name: "USA", code: "+1", zipcodes: ["10001", "90001", "73301"] },
//     { name: "UK", code: "+44", zipcodes: ["SW1A", "EC1A", "W1A"] },
//   ];

//   const selectedCountry = countries.find((c) => c.name === form.country);

//   const validate = () => {
//     const newErrors = {};

//     if (!form.firstName.trim()) newErrors.firstName = "First name required";
//     if (!form.lastName.trim()) newErrors.lastName = "Last name required";

//     if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
//       newErrors.email = "Invalid email address";
//     }

//     if (!/^\d{10}$/.test(form.phone)) {
//       newErrors.phone = "Phone must be 10 digits";
//     }

//     if (!form.password || form.password.length < 6) {
//       newErrors.password = "Password must be at least 6 characters";
//     }

//     if (form.password !== form.confirmPassword) {
//       newErrors.confirmPassword = "Passwords do not match";
//     }

//     if (!form.country) newErrors.country = "Country required";
//     if (!form.zipcode) newErrors.zipcode = "Zipcode required";

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setForm({ ...form, [name]: type === "checkbox" ? checked : value });

//     if (apiMessage) setApiMessage(""); // 🔥 clear message
//   };

//   // const handleSubmit = async (e) => {
//   //   e.preventDefault();
//   //   if (!validate()) return;

//   //   try {
//   //     await registerUser(form);

//   //     setModalType("success");
//   //     setModalMessage("Registration successful. Data sent to backend.");
//   //     setShowModal(true);
//   //   } catch (err) {
//   //     const backendMessage =
//   //       err?.response?.data?.message ||
//   //       error ||
//   //       "Registration failed. Please try again.";

//   //     setModalType("error");
//   //     setModalMessage(backendMessage);
//   //     setShowModal(true);
//   //   }
//   // };
//   // const handleSubmit = async (e) => {
//   //   e.preventDefault();
//   //   if (!validate()) return;

//   //   try {
//   //     await registerUser(form);

//   //     setModalType("success");
//   //     setModalMessage(
//   //       "Registration successful. Please check your email to verify your account.",
//   //     );
//   //     setShowModal(true);

//   //     // ✅ START WAITING FOR EMAIL VERIFICATION
//   //     // setWaitingForVerification(true);
//   //     startVerificationWatch(form.email);
//   //   } catch (err) {
//   //     const backendMessage =
//   //       err?.response?.data?.message ||
//   //       error ||
//   //       "Registration failed. Please try again.";

//   //     setModalType("error");
//   //     setModalMessage(backendMessage);
//   //     setShowModal(true);
//   //   }
//   // };

//   //working code previous
//   // const handleSubmit = async (e) => {
//   //   e.preventDefault();
//   //   if (!validate()) return;

//   //   try {
//   //     await registerUser(form);

//   //     setModalType("success");
//   //     setModalMessage("Registration successful. Check your email to verify.");
//   //     setShowModal(true);
//   //     startVerificationWatch(form.email);
//   //   } catch (err) {
//   //     const code = err?.response?.data?.code;
//   //     const message = err?.response?.data?.message || "Registration failed";

//   //     // 🔥 USER ALREADY EXISTS
//   //     if (code === "USER_ALREADY_EXISTS") {
//   //       setModalType("error");
//   //       setModalMessage("User already exists. Please login.");
//   //       setShowModal(true);
//   //       return;
//   //     }

//   //     setModalType("error");
//   //     setModalMessage(message);
//   //     setShowModal(true);
//   //   }
//   // };
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validate()) return;

//     try {
//       await registerUser(form);

//       setIsError(false);
//       setApiMessage("Registration successful. Check your email to verify.");

//       startVerificationWatch(form.email);
//     } catch (err) {
//       const code = err?.response?.data?.code;
//       const message = err?.response?.data?.message || "Registration failed";

//       if (code === "USER_ALREADY_EXISTS") {
//         setIsError(true);
//         setApiMessage("User already exists. Please login.");
//         return;
//       }

//       setIsError(true);
//       setApiMessage(message);
//     }
//   };
//   useEffect(() => {
//     if (isVerified) {
//       navigate("/loginpage");
//     }
//   }, [isVerified, navigate]);
//   // useEffect(() => {
//   //   if (!waitingForVerification || !form.email) return;

//   //   const interval = setInterval(async () => {
//   //     try {
//   //       const res = await axios.get(`${BASE_URL}/api/auth/check-verification`, {
//   //         params: { email: form.email },
//   //       });

//   //       if (res.data.verified) {
//   //         clearInterval(interval);
//   //         navigate("/loginpage");
//   //       }
//   //     } catch (err) {
//   //       // ignore polling errors
//   //     }
//   //   }, 5000); // check every 5 seconds

//   //   return () => clearInterval(interval);
//   // }, [waitingForVerification, form.email, navigate]);
//   return (
//     <>
//       <div className="back-btn">
//         <button className="rec-btn" onClick={() => navigate(-1)}>
//           Back
//         </button>
//       </div>
//       <div className="reg-page-wrapper">
//         <h2 className="reg-page-title">Register</h2>

//         <form className="reg-form" onSubmit={handleSubmit}>
//           <input
//             className="reg-input"
//             name="firstName"
//             placeholder="First Name"
//             onChange={handleChange}
//           />
//           {errors.firstName && <p className="reg-error">{errors.firstName}</p>}

//           <input
//             className="reg-input"
//             name="middleName"
//             placeholder="Middle Name"
//             onChange={handleChange}
//           />

//           <input
//             className="reg-input"
//             name="lastName"
//             placeholder="Last Name"
//             onChange={handleChange}
//           />
//           {errors.lastName && <p className="reg-error">{errors.lastName}</p>}

//           <input
//             className="reg-input"
//             name="email"
//             placeholder="Email Address"
//             onChange={handleChange}
//           />
//           {errors.email && <p className="reg-error">{errors.email}</p>}

//           <input
//             className="reg-input"
//             name="phone"
//             placeholder="Phone Number"
//             maxLength={10}
//             onChange={handleChange}
//           />
//           {errors.phone && <p className="reg-error">{errors.phone}</p>}

//           <input
//             className="reg-input"
//             type="password"
//             name="password"
//             placeholder="Password"
//             onChange={handleChange}
//           />
//           {errors.password && <p className="reg-error">{errors.password}</p>}

//           <input
//             className="reg-input"
//             type="password"
//             name="confirmPassword"
//             placeholder="Confirm Password"
//             onChange={handleChange}
//           />
//           {errors.confirmPassword && (
//             <p className="reg-error">{errors.confirmPassword}</p>
//           )}

//           <select className="reg-select" name="country" onChange={handleChange}>
//             <option value="">Select Country</option>
//             {countries.map((c) => (
//               <option key={c.name} value={c.name}>
//                 {c.name}
//               </option>
//             ))}
//           </select>
//           {errors.country && <p className="reg-error">{errors.country}</p>}

//           <select
//             className="reg-select"
//             name="countryCode"
//             onChange={handleChange}
//           >
//             <option value="">Country Code</option>
//             {countries.map((c) => (
//               <option key={c.code} value={c.code}>
//                 {c.code}
//               </option>
//             ))}
//           </select>

//           <input
//             className="reg-input"
//             name="zipcode"
//             placeholder="Zip / Postal Code"
//             maxLength={6} // or 5 / 10 based on your use
//             inputMode="numeric"
//             onChange={(e) => {
//               e.target.value = e.target.value.replace(/\D/g, "");
//               handleChange(e);
//             }}
//           />
//           {errors.zipcode && <p className="reg-error">{errors.zipcode}</p>}

//           <input
//             className="reg-input"
//             name="address1"
//             placeholder="Address Line 1"
//             onChange={handleChange}
//           />

//           <input
//             className="reg-input"
//             name="address2"
//             placeholder="Address Line 2"
//             onChange={handleChange}
//           />

//           <input
//             className="reg-input"
//             name="city"
//             placeholder="City"
//             onChange={handleChange}
//           />

//           <input
//             className="reg-input"
//             name="state"
//             placeholder="State"
//             onChange={handleChange}
//           />

//           <label className="reg-checkbox">
//             <input type="checkbox" name="isMFA" onChange={handleChange} />
//             Enable MFA
//           </label>
//           <label className="reg-checkbox">
//             <input
//               type="checkbox"
//               name="isPaid"
//               onChange={handleChange}
//               disabled
//             />
//             Subscribe
//           </label>

//           <button className="reg-submit-btn" disabled={loading}>
//             {loading ? "Registering..." : "Register"}
//           </button>
//           {apiMessage && (
//             <p className={isError ? "reg-error" : "reg-success"}>
//               {apiMessage}
//             </p>
//           )}
//         </form>
//       </div>
//     </>
//   );
// };

//new ui

const Register = () => {
  const { registerUser, loading, error } = useRegister();
  const { startVerificationWatch, isVerified } = useVerification();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
    isMFA: false,
    address1: "",
    address2: "",
    city: "",
    state: "",
    country: "",
    zipcode: "",
    countryCode: "",
    isPaid: false,
  });

  const [errors, setErrors] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [apiMessage, setApiMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [modalType, setModalType] = useState("success");
  const [waitingForVerification, setWaitingForVerification] = useState(false);

  const countries = [
    { name: "India", code: "+91", zipcodes: ["440001", "400001", "110001"] },
    { name: "USA", code: "+1", zipcodes: ["10001", "90001", "73301"] },
    { name: "UK", code: "+44", zipcodes: ["SW1A", "EC1A", "W1A"] },
  ];

  const selectedCountry = countries.find((c) => c.name === form.country);

  /* ================= VALIDATION ================= */
  const validate = () => {
    const newErrors = {};

    if (!form.firstName.trim()) newErrors.firstName = "First name required";
    if (!form.lastName.trim()) newErrors.lastName = "Last name required";

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
      newErrors.email = "Invalid email address";
    }

    if (!/^\d{10}$/.test(form.phone)) {
      newErrors.phone = "Phone must be 10 digits";
    }

    if (!form.password || form.password.length < 6) {
      newErrors.password = "Password must be at least 6 characters";
    }

    if (form.password !== form.confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }

    if (!form.country) newErrors.country = "Country required";
    if (!form.zipcode) newErrors.zipcode = "Zipcode required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  /* ================= HANDLERS ================= */
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({ ...form, [name]: type === "checkbox" ? checked : value });

    if (apiMessage) setApiMessage("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      await registerUser(form);

      setIsError(false);
      setApiMessage("Registration successful. Check your email to verify.");

      startVerificationWatch(form.email);
    } catch (err) {
      const code = err?.response?.data?.code;
      const message = err?.response?.data?.message || "Registration failed";

      if (code === "USER_ALREADY_EXISTS") {
        setIsError(true);
        setApiMessage("User already exists. Please login.");
        return;
      }

      setIsError(true);
      setApiMessage(message);
    }
  };

  useEffect(() => {
    if (isVerified) {
      navigate("/loginpage");
    }
  }, [isVerified, navigate]);

  return (
    <div className="reg-page">
      {/* ── NAV ── */}
      <nav className="reg-nav">
        <div className="reg-nav-inner">
          <div
            className="reg-logo"
            onClick={() => navigate("/")}
            role="button"
            tabIndex={0}
          >
            {/* Add your logo:  */}
            <span className="reg-logo-mark">
              <img src={qkLogo} alt="" className="login-logo-img" />
            </span>
            <span className="reg-logo-name">QuantKubera</span>
          </div>
          <div className="reg-nav-right">
            <span className="reg-nav-text">Already have an account?</span>
            <Link to="/loginpage" className="reg-nav-link">
              Login
            </Link>
          </div>
        </div>
      </nav>

      {/* ── FORM ── */}
      <div className="reg-container">
        <div className="reg-header">
          <h2>Create your account</h2>
        </div>

        <form className="reg-form" onSubmit={handleSubmit}>
          {/* ── PERSONAL INFO ── */}
          <div className="reg-section">
            <div className="reg-section-label">Personal information</div>
            <div className="reg-row-3">
              <div className="reg-field">
                <label htmlFor="firstName">First name</label>
                <input
                  id="firstName"
                  name="firstName"
                  placeholder="John"
                  value={form.firstName}
                  onChange={handleChange}
                />
                {errors.firstName && (
                  <p className="reg-error">{errors.firstName}</p>
                )}
              </div>
              <div className="reg-field">
                <label htmlFor="middleName">Middle name</label>
                <input
                  id="middleName"
                  name="middleName"
                  placeholder="Optional"
                  value={form.middleName}
                  onChange={handleChange}
                />
              </div>
              <div className="reg-field">
                <label htmlFor="lastName">Last name</label>
                <input
                  id="lastName"
                  name="lastName"
                  placeholder="Doe"
                  value={form.lastName}
                  onChange={handleChange}
                />
                {errors.lastName && (
                  <p className="reg-error">{errors.lastName}</p>
                )}
              </div>
            </div>
            <div className="reg-row">
              <div className="reg-field">
                <label htmlFor="email">Email address</label>
                <input
                  id="email"
                  name="email"
                  placeholder="you@example.com"
                  value={form.email}
                  onChange={handleChange}
                />
                {errors.email && <p className="reg-error">{errors.email}</p>}
              </div>
              <div className="reg-field">
                <label htmlFor="phone">Phone number</label>
                <input
                  id="phone"
                  name="phone"
                  placeholder="9876543210"
                  maxLength={10}
                  value={form.phone}
                  onChange={handleChange}
                />
                {errors.phone && <p className="reg-error">{errors.phone}</p>}
              </div>
            </div>
          </div>

          {/* ── PASSWORD ── */}
          <div className="reg-section">
            <div className="reg-section-label">Password</div>
            <div className="reg-row">
              <div className="reg-field">
                <label htmlFor="password">Password</label>
                <input
                  id="password"
                  type="password"
                  name="password"
                  placeholder="Min 6 characters"
                  value={form.password}
                  onChange={handleChange}
                />
                {errors.password && (
                  <p className="reg-error">{errors.password}</p>
                )}
              </div>
              <div className="reg-field">
                <label htmlFor="confirmPassword">Confirm password</label>
                <input
                  id="confirmPassword"
                  type="password"
                  name="confirmPassword"
                  placeholder="Re-enter password"
                  value={form.confirmPassword}
                  onChange={handleChange}
                />
                {errors.confirmPassword && (
                  <p className="reg-error">{errors.confirmPassword}</p>
                )}
              </div>
            </div>
          </div>

          {/* ── ADDRESS ── */}
          <div className="reg-section">
            <div className="reg-section-label">Address</div>
            <div className="reg-row-3">
              <div className="reg-field">
                <label htmlFor="country">Country</label>
                <select
                  id="country"
                  name="country"
                  value={form.country}
                  onChange={handleChange}
                >
                  <option value="">Select country</option>
                  {countries.map((c) => (
                    <option key={c.name} value={c.name}>
                      {c.name}
                    </option>
                  ))}
                </select>
                {errors.country && (
                  <p className="reg-error">{errors.country}</p>
                )}
              </div>
              <div className="reg-field">
                <label htmlFor="countryCode">Country code</label>
                <select
                  id="countryCode"
                  name="countryCode"
                  value={form.countryCode}
                  onChange={handleChange}
                >
                  <option value="">Select code</option>
                  {countries.map((c) => (
                    <option key={c.code} value={c.code}>
                      {c.code}
                    </option>
                  ))}
                </select>
              </div>
              <div className="reg-field">
                <label htmlFor="zipcode">Zip / postal code</label>
                <input
                  id="zipcode"
                  name="zipcode"
                  placeholder="400001"
                  maxLength={6}
                  inputMode="numeric"
                  value={form.zipcode}
                  onChange={(e) => {
                    e.target.value = e.target.value.replace(/\D/g, "");
                    handleChange(e);
                  }}
                />
                {errors.zipcode && (
                  <p className="reg-error">{errors.zipcode}</p>
                )}
              </div>
            </div>
            <div className="reg-field-full">
              <label htmlFor="address1">Address line 1</label>
              <input
                id="address1"
                name="address1"
                placeholder="Street address"
                value={form.address1}
                onChange={handleChange}
              />
            </div>
            <div className="reg-field-full">
              <label htmlFor="address2">Address line 2</label>
              <input
                id="address2"
                name="address2"
                placeholder="Apartment, suite, etc. (optional)"
                value={form.address2}
                onChange={handleChange}
              />
            </div>
            <div className="reg-row">
              <div className="reg-field">
                <label htmlFor="city">City</label>
                <input
                  id="city"
                  name="city"
                  placeholder="Mumbai"
                  value={form.city}
                  onChange={handleChange}
                />
              </div>
              <div className="reg-field">
                <label htmlFor="state">State</label>
                <input
                  id="state"
                  name="state"
                  placeholder="Maharashtra"
                  value={form.state}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>

          {/* ── PREFERENCES ── */}
          <div className="reg-section">
            <div className="reg-section-label">Preferences</div>
            <label className="reg-checkbox">
              <input
                type="checkbox"
                name="isMFA"
                checked={form.isMFA}
                onChange={handleChange}
              />
              <span className="reg-checkmark"></span>
              <div>
                <span className="reg-check-title">Enable MFA</span>
                <span className="reg-check-desc">
                  Add an extra layer of security to your account.
                </span>
              </div>
            </label>
            <label className="reg-checkbox">
              <input
                type="checkbox"
                name="isPaid"
                checked={form.isPaid}
                onChange={handleChange}
                disabled
              />
              <span className="reg-checkmark"></span>
              <div>
                <span className="reg-check-title">Subscribe</span>
                <span className="reg-check-desc">
                  Get notified about new features and market insights.
                </span>
              </div>
            </label>
          </div>

          {/* ── API MESSAGE ── */}
          {apiMessage && (
            <div className={`reg-api-msg ${isError ? "error" : "success"}`}>
              {apiMessage}
            </div>
          )}

          {/* ── SUBMIT ── */}
          <button type="submit" className="reg-submit" disabled={loading}>
            {loading ? "Creating account..." : "Create account"}
          </button>
        </form>

        <p className="reg-login-link">
          Already have an account?{" "}
          <Link to="/loginpage" className="reg-link">
            Login
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Register;
